import * as React from "react"
import type { IconProps } from "../types"

const CurrencyDollar = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeWidth={2}
          d="M11.9996 7.50013C10.5336 7.50013 9.5127 8.16499 9.5127 9.60082C9.5127 11.2458 10.7792 11.5986 11.9996 12.0123C13.22 12.426 14.4865 12.7789 14.4865 14.4238C14.4865 15.8597 13.4655 16.5245 11.9996 16.5245M11.9996 7.50013C13.0605 7.50013 13.8335 8.00152 14.2293 8.71198M11.9996 7.50013V5.5M11.9996 16.5245C10.9386 16.5245 10.1656 16.0231 9.76986 15.3127M11.9996 16.5245V18.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        />
      </svg>
    )
  }
)
CurrencyDollar.displayName = "CurrencyDollar"

export default CurrencyDollar
